import { singleton } from "tsyringe";
import { Consents } from "../types";
type Command = () => void;

@singleton()
export class ConsentResolver {
  private consentGiven: boolean;

  public resolve(
    consents: Consents,
    onConfirm: Command,
    onReject: Command,
  ): void {
    if (
      (consents.geoRequiresConsent && consents.gdprConsent) ||
      (consents.geoRequiresSignal && !consents.ccpaSignal) ||
      (!consents.geoRequiresSignal && !consents.geoRequiresConsent)
    ) {
      this.consentGiven = true;
      onConfirm();
    } else if (
      (consents.geoRequiresSignal && consents.ccpaSignal) ||
      (consents.geoRequiresConsent && !consents.gdprConsent)
    ) {
      this.consentGiven = false;
      onReject();
    }
  }

  getConsents(): boolean {
    return this.consentGiven;
  }
}
